import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

type ProfileGreetingProps = TypographyProps;

export function ProfileGreeting({ children, sx, ...props }: ProfileGreetingProps) {
    return (
        <Typography
            variant="h2"
            sx={{
                fontSize: '32px',
                fontWeight: 700,
                lineHeight: '44px',
                letterSpacing: 0,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Typography>
    );
}
